<template>
    <div>
        <div class="card" v-if="mov && mov.links && mov.links.length">
            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between py-2" v-for="(item, imx) in mov.links" :key="imx">
                    <div>
                        {{ item.model.item.search }}
                        <span class="small text-muted ml-2" v-if="item.model.st_lote && item.model.st_lote != 'Sem Lote'">Lote: {{ item.model.st_lote }}</span>
                    </div>
                    <div>
                        {{ item.model.in_quantidade }}
                        <span class="small text-muted ml-2">{{ item.model.item.st_unidade_estoque }}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['mov'], 
}
</script>
